module.exports = __webpack_public_path__ + "img/chivas-ferrari-logo.40e3031a.png";